import { gql } from '@apollo/client'

export const MY_EMAIL_TEMPLATES_QUERY = gql`
  query MyEmailTemplates {
    myEmailTemplates {
      id
      title
      subject
      bodyHtml
      createdAt
      updatedAt
    }
  }
`
